import styles from './identifierField.module.css'
import { Labels } from "../../../../../features/data-types"
import { FieldType, FieldValue, NumberField, SelectField, Validatable, option, O } from "../../../../../features/ui"
import { IdentifierType } from '../../../../system'
import { toList } from '../../../../../utils/listUtils'

type Props = {
    defaultIdentifierType?: IdentifierType
    defaultIdentifier?: number
    validation?: string
    onChangeIdentifierType?: (value?: IdentifierType) => void
    onChangeIdentifier?: (value?: number) => void
}

export const IdentifierField = (props: Props) => {
    const { defaultIdentifierType, defaultIdentifier, validation, onChangeIdentifierType, onChangeIdentifier } = props

    const handleChangeIdentifierType = (value?: FieldValue) => onChangeIdentifierType?.(value as O<IdentifierType>)

    const handleChangeIdentifier = (value?: FieldValue) => onChangeIdentifier?.(value as O<number>)

    return {
        name: 'identifier',
        type: FieldType.NUMBER,
        label: 'Documento',
        render: () => {
            return <div className={styles.container}>
                <SelectField
                    id="identifierType"
                    defaultValue={defaultIdentifierType}
                    options={Object.values(IdentifierType).map(type => option(type, Labels.identifierTypeLabel(type)))}
                    onChange={handleChangeIdentifierType}
                />
                <div>
                    <Validatable validations={toList(validation)} left>
                        <NumberField
                            id="identifier"
                            defaultValue={defaultIdentifier}
                            onChange={handleChangeIdentifier}
                        />
                    </Validatable>
                </div>
            </div>
        }
    }
}
